import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get banner List
export const getBannerSettingList = createAsyncThunk(
  "getBannerSettingList",
  async ({ search, pageLimit, pageCount }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `banners?search=${search}&page=${pageCount}&limit=${pageLimit}`
      );
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Get general setting List
export const getGeneralSettingList = createAsyncThunk(
  "getGeneralSettingList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get("general-settings");
      return response?.data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Create genearal setting
export const createGeneralSetting = createAsyncThunk(
  "createGeneralSetting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`general-settings`, data);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Get general setting List
export const getBillingSettingList = createAsyncThunk(
  "getBillingSettingList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get("billing-settings");
      return response?.data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Create billing setting
export const createBillingSetting = createAsyncThunk(
  "createBillingSetting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`billing-settings`, data);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Create gst setting
export const createBannerSetting = createAsyncThunk(
  "createBannerSetting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`banners`, data);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);
// Create gst setting
export const createGstSetting = createAsyncThunk(
  "createGstSetting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`gst`, data);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// update Sale Status
export const updateSaleStatus = createAsyncThunk(
  "updateSaleStatus",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`sales`, data);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Get sales id List
export const getSalesById = createAsyncThunk(
  "getSalesById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`sales/${id}`);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// update Sale Delete
export const saleDelete = createAsyncThunk(
  "saleDelete",
  async ({ ids }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`delete-sales`, {
        data: { ids: ids },
      });
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// update Banners
export const updateBanners = createAsyncThunk(
  "updateBanners",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`banners/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Banner
export const DeleteBanner = createAsyncThunk(
  "DeleteBanner",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`banners/${id}`);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Get FAQ List
export const getFAQList = createAsyncThunk(
  "getFAQList",
  async ({ search }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`faqs-list?search=${search}`);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Create FAQ Topic setting
export const createTopicFAQSetting = createAsyncThunk(
  "createTopicFAQSetting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`add-faq-topic`, data);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Create FAQ qa setting
export const createQAFAQSetting = createAsyncThunk(
  "createQAFAQSetting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`add-faq-qa`, data);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Delete FAQ
export const DeleteFAQ = createAsyncThunk(
  "DeleteFAQ",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`delete-faq/${id}`);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);
// Delete FAQ/QA
export const DeletefaqQA = createAsyncThunk(
  "DeletefaqQA",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`delete-faq-qa/${id}`);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      if (!error) {
        throw error?.response;
      }
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// update FAQ/QA Status
export const updatefaqQAStatus = createAsyncThunk(
  "updatefaqQAStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`update-faq-qa/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// update FAQ Status
export const updateFAQStatus = createAsyncThunk(
  "updateFAQStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`update-faq/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const settingSlice = createSlice({
  name: "setting",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // Get getBannerSettingList
      .addCase(getBannerSettingList?.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBannerSettingList.fulfilled, (state, action) => {
        state.loading = false;
        state.getBannerSettingListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getBannerSettingList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get getFAQList
      .addCase(getFAQList?.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFAQList.fulfilled, (state, action) => {
        state.loading = false;
        state.getFAQListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getFAQList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })

      // Get getGeneralSettingList
      .addCase(getGeneralSettingList?.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGeneralSettingList.fulfilled, (state, action) => {
        state.loading = false;
        state.getGeneralSettingListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getGeneralSettingList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })

      // Get getBillingSettingList
      .addCase(getBillingSettingList?.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBillingSettingList.fulfilled, (state, action) => {
        state.loading = false;
        state.getBillingSettingListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getBillingSettingList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })

      // Get getSalesById
      .addCase(getSalesById?.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesById.fulfilled, (state, action) => {
        state.loading = false;
        state.getSalesByIdStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSalesById.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = settingSlice;
export default reducer;
